// extracted by mini-css-extract-plugin
export default {"wrap":"Loader_wrap__lHNlp"};